const ResetIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66406 8.33333C1.66406 8.33333 3.33488 6.05685 4.69226 4.69854C6.04964 3.34022 7.92539 2.5 9.9974 2.5C14.1395 2.5 17.4974 5.85786 17.4974 10C17.4974 14.1421 14.1395 17.5 9.9974 17.5C6.57815 17.5 3.69332 15.2119 2.79053 12.0833M1.66406 8.33333V3.33333M1.66406 8.33333H6.66406"
        stroke="#F1F1F1"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ResetIcon;
